import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Effect$dClass from "../Effect.Class/index.js";
import * as Effect$dUncurried from "../Effect.Uncurried/index.js";
import * as Foreign$dObject from "../Foreign.Object/index.js";
import * as Specular$dDom$dBrowser from "../Specular.Dom.Browser/index.js";
import * as Specular$dDom$dBuilder from "../Specular.Dom.Builder/index.js";
import * as Specular$dDom$dWidgets$dInput from "../Specular.Dom.Widgets.Input/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dInternal$dEffect from "../Specular.Internal.Effect/index.js";
import * as Specular$dInternal$dProfiling from "../Specular.Internal.Profiling/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Specular$dProfiling from "../Specular.Profiling/index.js";
import {_addClass, _initClasses, _stopPropagation, setProperty} from "./foreign.js";
const measure = /* #__PURE__ */ Specular$dProfiling.measure(Effect$dClass.monadEffectEffect);
const subscribeDyn_ = /* #__PURE__ */ Specular$dFRP$dBase.subscribeDyn_({
  MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
  MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
});
const Prop = x => x;
const withTargetChecked = cb => event => {
  const $0 = Specular$dDom$dWidgets$dInput.getCheckboxChecked(event.target);
  return () => {
    const value = $0();
    return cb(value)();
  };
};
const withTargetValue = cb => event => {
  const $0 = Specular$dDom$dWidgets$dInput.getTextInputValue(event.target);
  return () => {
    const value = $0();
    return cb(value)();
  };
};
const text = str => env => {
  const node = Specular$dDom$dBrowser.createTextNodeImpl(str)();
  return Specular$dDom$dBrowser.appendChildImpl(node)(env.parent)();
};
const stopPropagation = /* #__PURE__ */ Effect$dUncurried.runEffectFn1(_stopPropagation);
const semigroupProp = {
  append: v => v1 => (node, cleanups) => {
    v(node, cleanups);
    return v1(node, cleanups);
  }
};
const preventDefault = Specular$dDom$dBrowser.preventDefault;
const on = eventType => cb => (node, _cleanups) => {Specular$dDom$dBrowser.addEventListenerImpl(eventType)(e => measure("event: " + eventType)(cb(e)))(node)();};
const onClick = cb => on("click")(cb);
const onClick_ = cb => onClick(v => cb);
const monoidProp = {mempty: (v, v1) => {}, Semigroup0: () => semigroupProp};
const mempty3 = v => monoidProp.mempty;
const initElement = (env, node, props, body) => {
  const mark = Specular$dInternal$dProfiling.begin("el");
  const result = Specular$dDom$dBuilder.runBuilder$p({...env, parent: node}, body);
  for (const v of props) {
    v(node, env.cleanup);
  }
  Specular$dDom$dBrowser.appendChildImpl(node)(env.parent)();
  Specular$dInternal$dProfiling.end(mark);
  return result;
};
const el$p = tagName => props => body => env => {
  const node = Specular$dDom$dBrowser.createElementImpl(tagName)();
  const result = initElement(env, node, props, body);
  return Data$dTuple.$Tuple(node, result);
};
const el = tagName => props => body => env => {
  const node = Specular$dDom$dBrowser.createElementImpl(tagName)();
  return initElement(env, node, props, body);
};
const el_ = tagName => el(tagName)([]);
const dynText = strD => Specular$dInternal$dRIO.bindImpl(env => {
  const node = Specular$dDom$dBrowser.createTextNodeImpl("")();
  Specular$dDom$dBrowser.appendChildImpl(node)(env.parent)();
  return node;
})(node => subscribeDyn_(Specular$dDom$dBrowser.setTextImpl(node))(strD));
const classes = clss => (node, v) => {
  for (const cls of clss) {
    _addClass(node, cls);
  }
};
const class_ = cls => (node, v) => _addClass(node, cls);
const classWhen = enabled => cls => {
  if (enabled) { return class_(cls); }
  return monoidProp.mempty;
};
const classUnless = enabled => cls => {
  if (enabled) { return monoidProp.mempty; }
  return class_(cls);
};
const attrs = a => (node, v) => Specular$dDom$dBrowser._setAttributes(node, a);
const attrsUnless = v => {
  if (!v) { return attrs; }
  if (v) { return mempty3; }
  $runtime.fail();
};
const attrsWhen = v => {
  if (v) { return attrs; }
  return mempty3;
};
const attr = name => value => attrs((() => {
  const $0 = {};
  $0[name] = value;
  return $0;
})());
const attrUnless = v => v1 => v2 => {
  if (!v) { return attr(v1)(v2); }
  if (v) { return monoidProp.mempty; }
  $runtime.fail();
};
const attrWhen = v => v1 => v2 => {
  if (v) { return attr(v1)(v2); }
  return monoidProp.mempty;
};
const _subscribeDyn = (cleanups, dyn, handler) => {
  const $0 = Effect$dUncurried.runEffectFn1(handler);
  const unsub = Specular$dFRP$dBase._subscribeEvent($0, dyn);
  Specular$dInternal$dEffect.pushDelayed(cleanups)(unsub)();
  const initialValue = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(dyn)();
  return handler(initialValue);
};
const attrsD = dynAttrs => (node, cleanups) => {
  let attrsRef = Foreign$dObject.empty;
  return _subscribeDyn(
    cleanups,
    dynAttrs,
    newAttrs => {
      const oldAttrs = attrsRef;
      attrsRef = newAttrs;
      Specular$dDom$dBrowser.removeAttributesImpl(node)(Data$dArray.filterImpl(k => !Object.hasOwn(newAttrs, k), Object.keys(oldAttrs)))();
      return Specular$dDom$dBrowser._setAttributes(
        node,
        Foreign$dObject.filterWithKey(k => v => {
          const $0 = Foreign$dObject._lookup(Data$dMaybe.Nothing, Data$dMaybe.Just, k, oldAttrs);
          if ($0.tag === "Nothing") { return true; }
          if ($0.tag === "Just") { return $0._1 !== v; }
          return true;
        })(newAttrs)
      );
    }
  );
};
const attrD = name => valD => attrsD(Specular$dFRP$dBase.functorDynamic.map(v => {
  const $0 = {};
  $0[name] = v;
  return $0;
})(valD));
const attrUnlessD = conditionD => name => value => attrsD(Specular$dFRP$dBase.functorDynamic.map(v => {
  if (v) { return Foreign$dObject.empty; }
  return (() => {
    const $0 = {};
    $0[name] = value;
    return $0;
  })();
})(conditionD));
const attrWhenD = conditionD => name => value => attrsD(Specular$dFRP$dBase.functorDynamic.map(v => {
  if (v) {
    const $0 = {};
    $0[name] = value;
    return $0;
  }
  return Foreign$dObject.empty;
})(conditionD));
const attrsUnlessD = conditionD => attrs$p => attrsD(Specular$dFRP$dBase.functorDynamic.map(v => {
  if (v) { return Foreign$dObject.empty; }
  return attrs$p;
})(conditionD));
const attrsWhenD = conditionD => attrs$p => attrsD(Specular$dFRP$dBase.functorDynamic.map(v => {
  if (v) { return attrs$p; }
  return Foreign$dObject.empty;
})(conditionD));
const classesD = clssD => (node, cleanups) => {
  const updateClasses = _initClasses(node);
  return _subscribeDyn(cleanups, clssD, updateClasses);
};
const classUnlessD = enabled => cls => classesD(Specular$dFRP$dBase.functorDynamic.map(v => {
  if (v) { return []; }
  return [cls];
})(enabled));
const classWhenD = enabled => cls => classesD(Specular$dFRP$dBase.functorDynamic.map(v => {
  if (v) { return [cls]; }
  return [];
})(enabled));
const propertyD = property => dyn => (node, cleanups) => _subscribeDyn(cleanups, dyn, v => setProperty(node, property, v));
const checkedD = /* #__PURE__ */ propertyD("checked");
const bindChecked = v => {
  const $0 = on("change")(withTargetChecked(x => v._2(v$1 => x)));
  return (node, cleanups) => {
    propertyD("checked")(v._1)(node, cleanups);
    return $0(node, cleanups);
  };
};
const indeterminateD = /* #__PURE__ */ propertyD("indeterminate");
const valueD = /* #__PURE__ */ propertyD("value");
const bindValueOnChange = v => {
  const $0 = on("change")(withTargetValue(x => v._2(v$1 => x)));
  return (node, cleanups) => {
    propertyD("value")(v._1)(node, cleanups);
    return $0(node, cleanups);
  };
};
const bindValueOnInput = v => {
  const $0 = on("input")(withTargetValue(x => v._2(v$1 => x)));
  return (node, cleanups) => {
    propertyD("value")(v._1)(node, cleanups);
    return $0(node, cleanups);
  };
};
export {
  Prop,
  _subscribeDyn,
  attr,
  attrD,
  attrUnless,
  attrUnlessD,
  attrWhen,
  attrWhenD,
  attrs,
  attrsD,
  attrsUnless,
  attrsUnlessD,
  attrsWhen,
  attrsWhenD,
  bindChecked,
  bindValueOnChange,
  bindValueOnInput,
  checkedD,
  classUnless,
  classUnlessD,
  classWhen,
  classWhenD,
  class_,
  classes,
  classesD,
  dynText,
  el,
  el$p,
  el_,
  indeterminateD,
  initElement,
  measure,
  mempty3,
  monoidProp,
  on,
  onClick,
  onClick_,
  preventDefault,
  propertyD,
  semigroupProp,
  stopPropagation,
  subscribeDyn_,
  text,
  valueD,
  withTargetChecked,
  withTargetValue
};
export * from "./foreign.js";
